import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AreaComponent } from './area.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: AreaComponent,
        data: {
          title: "Yo‘nalishalar",
          breadcrumb: "Yo‘nalishalar"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AreaRoutingModule { }
